if (!customElements.get('recently-viewed-products')) {
    class RecentlyViewedProducts extends ProductCardCollection {
        constructor() {
            super();
            const products = this.getRecentlyViewedProducts();
            this
                .usingTemplateSelector("template#recently-viewed-product-card")
                .displayProducts(products);
        }

        getRecentlyViewedProducts() {
            const products = JSON.parse(window.localStorage.getItem("products"));
            const { showCount } = window.recentlyViewedProductsConfiguration;

            return document.cookie.split(/; */).map(parts => {
                const [name, createdAt] = parts.split("=");
                if (name.includes('product_viewed_')) {
                    return {
                        id: parseInt(name.replace('product_viewed_', '')),
                        createdAt
                    }
                }
                return null;
            })
                .filter(res => res != null)
                .sort((a, b) => b.createdAt - a.createdAt) // reverse
                .map(res => products.find(p => p.id == res.id))
                .splice(0, showCount)
        }
    }

    customElements.define("recently-viewed-products", RecentlyViewedProducts);
}

const onDOMContentLoaded = () => {
    if (!window.recentlyViewedProductsConfiguration) {
        console.error("recently-viewed-products.js is loaded on a page without configuration.");
        return;
    }

    const {
        recordView,
        expiry,
        currentProduct
    } = window.recentlyViewedProductsConfiguration;
    if (!recordView) {
        return;
    }

    if (Cookies && currentProduct && expiry) {
        const ts = Math.floor(Date.now() / 1000);
        Cookies.set(`product_viewed_${currentProduct.id}`, ts, { expires: parseInt(expiry) });
        saveProduct(currentProduct);

        console.log(`Saved product ${currentProduct.title} as recently viewed.`);
    }
};

const saveProduct = (product) => {
    let products = [];

    try {
        products = JSON.parse(window.localStorage.getItem("products"));
        if (!products) {
            products = [];
        }
    } catch (e) {
        console.error("Failed to read products from localStorage");
        console.error(e);
    }

    const updatedProducts = [
        ...products.filter(p => p.id != product.id),
        product
    ];
    window.localStorage.setItem("products", JSON.stringify(updatedProducts));
}

document.addEventListener("DOMContentLoaded", onDOMContentLoaded, false);